// extracted by mini-css-extract-plugin
export default {"chart":"RoundGraph_chart__vqip8","legend":"RoundGraph_legend__SGE9i","title":"RoundGraph_title__EH8Ri","percent":"RoundGraph_percent__KZ6dM"};